import React from "react"
import styled from "@emotion/styled"
import { StaticImage } from "gatsby-plugin-image"
import ContactFom from "./contact-form"
import Arrow from "../../assets/arrow.inline.svg"

const Contact = ({ className }) => {
  return (
    <section className={className}>
      <div className="inner">
        <h2 className="text-center">
          <em>Mais que sont-ils devenus&nbsp;?</em>
        </h2>
        <StyledImagesWrapper>
          <StaticImage
            placeholder="blurred"
            width={450}
            src="../../images/index-contact-boy-surf.png"
            alt=""
          />
          <StyledArrow />
          <StyledText className="h4 text-center">
            Réssucitée pour elle
          </StyledText>
          <StaticImage
            placeholder="blurred"
            width={450}
            src="../../images/index-contact-girl-yoga.png"
            alt=""
          />
        </StyledImagesWrapper>
        <div className="grid">
          <p className="dark margin-bottom-sm text-sm-center">
            Les fabuleuses histoires de tes produits collectés et transformés,
            c'est par ici :
          </p>
          <ContactFom />
        </div>
        <StyledParagraph className="margin-bottom text-center text_small">
          * Pas de pub, pas de partage de vos données personnelles à des fins
          commerciales. Vous pouvez vous désabonner à tout moment en cliquant
          sur le lien de désabonnement en bas de nos newletters.
        </StyledParagraph>
      </div>
    </section>
  )
}

const StyledParagraph = styled.p`
  max-width: 100%;
  margin-top: 1rem;
`

const StyledImagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  position: relative;
  div:first-of-type {
    margin-bottom: 2em;
  }
  @media only screen and (min-width: 650px) {
    justify-content: space-evenly;
    flex-direction: row;
    div:first-of-type {
      margin-bottom: 0;
    }
  }
`

const StyledArrow = styled(Arrow)`
  position: absolute;
  z-index: 1;
  width: 60%;
  left: 15%;
  top: 35%;
  transform: rotate(70deg);
  @media only screen and (min-width: 650px) {
    transform: rotate(0deg);
    top: 25%;
    left: 38%;
    width: 25%;
  }
`

const StyledText = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1;
  top: 70%;
  @media only screen and (min-width: 650px) {
    top: 10%;
  }
`

export default Contact
